<template>
  <div id="app">
    <keep-alive exclude="Collection,History">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      type: 2
    }
  },
  created() {
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  methods: {
  }

}
</script>

<style>
@import "assets/css/base.css";

#app {
  overflow-y: scroll;
}
html,body,#app{
  height: 100%;
  width: 100%;
}
</style>
